
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
// Material Dashboard 2 React example components
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useNavigate } from 'react-router-dom';
import Config from "config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { Loader } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";
import CustomerAddress from "./CustomerAddress";
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Backdrop, CircularProgress } from '@mui/material'

function CustomerView() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [customerData, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();

  const data = () => {
    setIsLoading(true);
    axios({
      url: BASE + "api/customer/view/" + id,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setData(response.data);
        }
        else {
          if (message != '')
            toast.error(t(message))
            (function () {
              const redirectTimeout = setTimeout(() => {
                clearTimeout(redirectTimeout);
                navigate("/customer/list");
              }, 3000);
            })()
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
        (function () {
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate("/customer/list");
          }, 3000);
        })()
      }
    })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }


  useEffect(() => {
    data();
  }, []);

  const renderAddress = (addressData) => {
    const addressArray = JSON.parse(addressData);
    return (
      <div>
        {addressArray.map((address, index) => (
          <CustomerAddress key={index} index={index} address={address} />
        ))}
      </div>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("Customer profile")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading} ><CircularProgress color="inherit" /></Backdrop>
      {(customerData.data && customerData.data.customerInfo) ?
        <Grid item xs={12}>
          <Card mb={2} variant="outlined">
            <CardContent>
              <Grid item xs={12} my={2}>
                <Typography variant="h6" color="text.secondary" gutterBottom>
                  {t('Customer details and addressess')}
                </Typography>
              </Grid>
              <Grid container spacing={0} mt={1}>
                <Grid item sm={6} xs={12}>
                  <Typography variant="h6" className="generalFont" color="text.secondary" gutterBottom>
                    {t('Customer details')}
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("First name")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {(customerData.data.customerInfo.firstName) ? customerData.data.customerInfo.firstName : '-'}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("Last name")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {(customerData.data.customerInfo.lastName) ? customerData.data.customerInfo.lastName : '-'}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("email")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {(customerData.data.customerInfo.email) ? customerData.data.customerInfo.email+" " : '-'}
                        {(customerData.data.customerInfo.verifiedEmail) ? <span className="verifiedEmail"> Verified</span> : <span className="NotVerifiedEmail"> Not verified </span>}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("Phone")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {(customerData.data.customerInfo.phone) ? customerData.data.customerInfo.phone : '-'}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("Shopify Id")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {(customerData.data.customerInfo.shopifyId) ? customerData.data.customerInfo.shopifyId : '-'}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("Currency")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {(customerData.data.customerInfo.currency) ? customerData.data.customerInfo.currency : '-'}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("State")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {customerData.data.customerInfo.state}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("Orders count")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {customerData.data.customerInfo.ordersCount}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("Last shopify order id")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {(customerData.data.customerInfo.lastOrderId) ? customerData.data.customerInfo.lastOrderId : '-'}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("Last shopify order name")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {(customerData.data.customerInfo.lastOrderName) ? customerData.data.customerInfo.lastOrderName : '-'}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("Total spend")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {customerData.data.customerInfo.totalSpent}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("Note")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {(customerData.data.customerInfo.note) ? customerData.data.customerInfo.note : '-'}
                      </div>
                    </Box>
                  </Typography>
                  <Typography className="generalFont" component="div" gutterBottom>
                    <Box className="addressBox">
                      <div className="customerBoxLeft">{t("Tags")}</div>
                      <div className="customerBoxMiddle">:</div>
                      <div className="customerBoxRight">
                        {(customerData.data.customerInfo.tags) ? customerData.data.customerInfo.tags : '-'}
                      </div>
                    </Box>
                  </Typography>
                </Grid>
                <Grid item sm={6} xs={12}>
                    <Typography variant="h6" className="generalFont" color="text.secondary" gutterBottom>
                      {t('Customer Addressess')}
                    </Typography>
                  {(customerData.data.customerInfo.addresses) ? renderAddress(customerData.data.customerInfo.addresses) : null}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        :
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox>{t('noRecordsExistsInVendorTable')}</MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      }

    </DashboardLayout>
  );
}

export default CustomerView;
